export enum CrewManagementType {
  TripBased = 1,
  ActivityBased = 2,
}
